import React from 'react';
import FilterBar from '../ui/FilterBar';
import './FiltersBar.css';

export default function FiltersBar(props) {
  return <FilterBar {...props} />;
}
